/**
 * Code for MSH Recent Viewed Page Module
 */
import $ from "jquery";

class MSHFavoriteFilter
{
    constructor(filter_name, listing_container_id, view_more_btn_id, pager_id) {
      this.filterName = filter_name;
      this.listingContainerId = listing_container_id;
      this.viewMoreBtnId = view_more_btn_id;
      this.pagerId = pager_id;
    }

    init() {
        var myInstance = this;

        $(myInstance.viewMoreBtnId).on("click", function () {
            myInstance.viewMoreFavorites();
        });
    }

    viewMoreFavorites() {
        var myInstance = this;
        var pageSize = $(myInstance.pagerId).val();

        window.showPreLoader();
        
        $.ajax({
            url: '/favorites/viewmorefavorites/',
            data: { filter: myInstance.filterName, currentPageSize: pageSize },
            success: function (resp) {
                if (resp) {
                    if (resp.Success) {
                        $(myInstance.listingContainerId).html(resp.Data.Html.Result);
                        $(myInstance.listingContainerId).foundation();
                        lozadObserver();
                        let likeButtons = $(myInstance.listingContainerId + " .like-button");
                        window.highlightLikeButtons(likeButtons, myInstance.filterName.toLowerCase());
                        window.hidePreLoader();
                        myInstance.init();
                    }
                }
            }
        });
    }
}

(new MSHFavoriteFilter('Community', '#favorite-community-listing', '#favorite-community-viewmore', '#favorite-community-currentpagesize')).init();
(new MSHFavoriteFilter('Plan', '#favorite-plan-listing', '#favorite-plan-viewmore', '#favorite-plan-currentpagesize')).init();
(new MSHFavoriteFilter('Lot', '#favorite-lot-listing', '#favorite-lot-viewmore', '#favorite-lot-currentpagesize')).init();
(new MSHFavoriteFilter('Event', '#favorite-event-listing', '#favorite-event-viewmore', '#favorite-event-currentpagesize')).init();
